import { createFileRoute, redirect } from "@tanstack/react-router";
import { setPendingModal } from "../../../libs/pending-modal";

export const Route = createFileRoute("/_authed/d/$distributionCode")({
  loader: async ({ params: { distributionCode } }) => {
    const data: DistributionCodeModalState = {
      type: "distribution-code",
      data: { distributionCode },
    };
    setPendingModal(data);

    return redirect({ to: "/", replace: true });
  },
});
